import { arrType, datatypes, inputTypes } from "data/globalData";

import { REPORT_MODES } from "../data";
import { STATUS_ORDER } from "./reportUi";
import { MRP_GROUP_OPTIONS } from "./reportColumns";

const CONSTRAINTS = { NOTNULL: false, DISPLAY: true, UNIQUE: false };

const buildColumn = (name, key, inputType, list, width) => ({
	name,
	key,
	input_type: inputType,
	data_type: datatypes.STRING.key,
	constraints: CONSTRAINTS,
	width,
	option_data: { type: arrType, list: list || [] },
});

const asOptions = (values) => (values || []).map((v) => ({ key: v, name: v }));

/** Keep dynamically-fetched values (e.g. distinct statuses present in the
 * current dataset) in the same left-to-right funnel order as STATUS_ORDER,
 * instead of whatever order the backend happened to return them in. */
const sortByCanonicalOrder = (values, order) =>
	[...(values || [])].sort((a, b) => {
		const ai = order.indexOf(a);
		const bi = order.indexOf(b);
		if (ai === -1 && bi === -1) return 0;
		if (ai === -1) return 1;
		if (bi === -1) return -1;
		return ai - bi;
	});

const storeOptions = (stores) =>
	(stores || []).map((s) => ({
		key: s.store_id,
		name: s.mapping_code ? `${s.store_name} (${s.mapping_code})` : s.store_name,
	}));

/** Filter bar definition — driven by the shared RenderInputField.
 * Widths are kept compact on purpose so all filters line up in a single row. */
export const buildReportFilterColumns = (options = {}) => [
	buildColumn(
		"Submission Type",
		"mode",
		inputTypes.SELECT.key,
		REPORT_MODES.map((m) => ({ key: m.key, name: m.label })),
		160
	),
	buildColumn("Stores", "store_id", inputTypes.MULTIPLE_SELECT.key, storeOptions(options.stores), 170),
	buildColumn(
		"Approval Stage",
		"status",
		inputTypes.MULTIPLE_SELECT.key,
		asOptions(
			sortByCanonicalOrder(options.statuses?.length ? options.statuses : STATUS_ORDER, STATUS_ORDER)
		),
		150
	),
	buildColumn("Grade", "grade", inputTypes.MULTIPLE_SELECT.key, asOptions(options.grades), 105),
	buildColumn("City tier", "city_tier", inputTypes.MULTIPLE_SELECT.key, asOptions(options.city_tiers), 115),
	buildColumn("Division", "division", inputTypes.MULTIPLE_SELECT.key, asOptions(options.divisions), 120),
	buildColumn("Category", "category", inputTypes.MULTIPLE_SELECT.key, asOptions(options.categories), 125),
];

export const MRP_GROUP_COLUMN = buildColumn(
	"Group by",
	"group_by",
	inputTypes.SELECT.key,
	MRP_GROUP_OPTIONS.map((o) => ({ key: o.key, name: o.label })),
	215
);

export const DEFAULT_REPORT_FILTERS = {
	mode: "LATEST_SUBMITTED",
	store_id: [],
	status: [],
	grade: [],
	city_tier: [],
	division: [],
	category: [],
	group_by: "category",
};

/** Everything except group_by, which only re-pivots the MRP section. */
export const MULTI_FILTER_KEYS = ["store_id", "status", "grade", "city_tier", "division", "category"];
